import { ITrialLesson } from "../../../entities/trialLesson";
import {
    formatCalendarDayTime,
    getCalendarDaySlots,
    getCalendarDayStart,
    getCalendarDayVisibleRange,
    getCalendarEventTimeRange,
    getCalendarSlotDateEnd,
} from "../../../shared/lib/helpers/calendarDayDate";

export const formatTrialTime = formatCalendarDayTime
export const getTrialDayStart = getCalendarDayStart
export const getTrialDaySlots = getCalendarDaySlots
export const getTrialSlotDateEnd = getCalendarSlotDateEnd

export const getTrialLessonTimeRange = (
    lesson: ITrialLesson,
    timeFormatter = formatTrialTime,
): string => {
    return getCalendarEventTimeRange(lesson, timeFormatter)
}

export const getTrialVisibleRange = getCalendarDayVisibleRange
